import { PROJECTMEMBERLIST_SUCCESS, PROJECTMEMBERLIST_FAIL } from '../actionTypes';

const initialState = {
    user: null,
    loading: false
};

const projectMemberListReducer = (state = initialState, action) => {
    switch (action.type) {
        case PROJECTMEMBERLIST_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case PROJECTMEMBERLIST_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default projectMemberListReducer;
